export const getTotalSupply =
// REPLACE THIS WITH YOUR CONTRACT NAME + ADDRESS
`
import BottomShot from 0xf46053abcb3b2288;

pub fun main(): UInt64 {

    return BottomShot.totalSupply;

}
`